export default {
    pageCategory: () => 'Homepage',
    rollUpBucket: () => 'HomePage',
    pageType: () => 'HomePage',
};
